var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chatExtract-detail" },
    [
      _c("div", { staticClass: "breadcrumb" }, [
        _c(
          "span",
          { staticClass: "breadcrumb-item", on: { click: _vm.backToIndex } },
          [_vm._v("首页")]
        ),
        _c("i", {
          staticClass: "breadcrumb-item separator el-icon-arrow-right",
        }),
        _c("span", { staticClass: "breadcrumb-item current" }, [
          _vm._v("记录详情"),
        ]),
      ]),
      _c("div", { staticClass: "extract-content" }, [
        _c(
          "div",
          { staticClass: "extract-content-template" },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.title,
                  placement: "top",
                  disabled: _vm.isShowTooltip,
                  "popper-class": "custom-zyq-prpper",
                },
              },
              [
                _c(
                  "p",
                  {
                    ref: "titleRef",
                    staticClass: "template-title",
                    on: {
                      mouseenter: function ($event) {
                        return _vm.mouseEnterShowTooltip("titleRef")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.title) + " ")]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "keywords-box" },
              _vm._l(_vm.keyword, function (item, index) {
                return _c(
                  "el-tooltip",
                  {
                    key: index,
                    attrs: {
                      effect: "dark",
                      content: item,
                      placement: "top",
                      disabled: _vm.isShowTooltip,
                      "popper-class": "custom-zyq-prpper",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: `keywordRef${index}`,
                        refInFor: true,
                        staticClass: "keywords-box-item",
                        on: {
                          mouseenter: function ($event) {
                            return _vm.mouseEnterShowTooltip(
                              `keywordRef${index}`
                            )
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item))])]
                    ),
                  ]
                )
              }),
              1
            ),
            _c("div", { staticClass: "content" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content",
                  },
                ],
                staticStyle: { width: "100%", height: "100%", resize: "none" },
                domProps: { value: _vm.content },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.content = $event.target.value
                    },
                    _vm.handleInputClick,
                  ],
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "words" }, [
                _vm._v("全文：" + _vm._s(_vm.content.length) + "字"),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "extract-ai" },
          [
            _c("chat-frame", {
              ref: "chatFrameRefs",
              staticClass: "chat-frame",
              attrs: {
                custom: true,
                "word-extract-index": _vm.wordExtractIndex,
                "conversation-id": _vm.conversationId,
              },
              on: {
                setInput: _vm.setInput,
                resetAnswer: _vm.resetAnswer,
                createTopic: _vm.createTopic,
                openRevision: _vm.openRevision,
                addTemp: _vm.addTemp,
                clearHistory: _vm.clearHistory,
              },
            }),
            _c(
              "div",
              { staticClass: "center-bottom" },
              [
                _c(
                  "div",
                  { staticClass: "tip-area" },
                  [
                    _c("div", { staticClass: "tip-options-left" }, [
                      _c(
                        "div",
                        {
                          staticClass: "tip-button",
                          on: { click: _vm.restartSession },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "type-icon",
                            attrs: { "icon-class": "dialogue" },
                          }),
                          _c("span", [_vm._v("全新对话")]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tip-button",
                          on: {
                            click: function ($event) {
                              _vm.isShowTipPannel = !_vm.isShowTipPannel
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "type-icon",
                            attrs: { "icon-class": "temp" },
                          }),
                          _c("span", [_vm._v("提示词模版")]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tip-button",
                          on: { click: _vm.addOriginal },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "type-icon",
                            attrs: { "icon-class": "original" },
                          }),
                          _c("span", [_vm._v("加入原文")]),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "transition",
                      { attrs: { name: "tip-dialog" } },
                      [
                        _vm.isShowTipPannel
                          ? _c("TipDialog", {
                              ref: "tipDialogRef",
                              on: {
                                close: function ($event) {
                                  _vm.isShowTipPannel = false
                                },
                                delete: _vm.handleDeleteClick,
                                tempClick: _vm.handleTemplateClick,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("chat-input", {
                  ref: "chatInputRefs",
                  attrs: {
                    content: _vm.inputContent,
                    original: _vm.content,
                    "conversation-id": _vm.conversationId,
                    placeholder: "请输入问题或提出要求",
                    "chat-value-limit": 10000,
                  },
                  on: {
                    changeModel: _vm.setAIModelType,
                    userInput: _vm.handleUserInput,
                    changeInput: _vm.handleChangeInput,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "CustomDialog",
        _vm._b(
          {
            attrs: { visiable: _vm.showDeleteDialog },
            on: {
              "update:visiable": function ($event) {
                _vm.showDeleteDialog = $event
              },
              close: function ($event) {
                _vm.showDeleteDialog = false
              },
              confirm: _vm.handleDeleteConfirm,
            },
          },
          "CustomDialog",
          _vm.dialogDetailObj,
          false
        )
      ),
      _c(
        "CustomDialog",
        _vm._b(
          {
            attrs: {
              "is-clear-history": true,
              visiable: _vm.showClearHistoryDialog,
            },
            on: {
              "update:visiable": function ($event) {
                _vm.showClearHistoryDialog = $event
              },
              close: function ($event) {
                _vm.showClearHistoryDialog = false
              },
              confirm: _vm.handleClearHistoryConfirm,
            },
          },
          "CustomDialog",
          _vm.dialogDetailObj,
          false
        )
      ),
      _c("CreateUpdateDialog", {
        ref: "createUpdateDialogRef",
        attrs: { "dialog-show": _vm.showCreateOrUpdateDialog },
        on: {
          "update:dialogShow": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
          "update:dialog-show": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
          "updata:dialogShow": function ($event) {
            _vm.showCreateOrUpdateDialog = $event
          },
        },
      }),
      _vm.showCreateOrUpdateDialog
        ? _c("div", { staticClass: "mask2" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }